import { newState } from '@/store/dataAccess/moduleDataAccessState'

function persistState(state) {
  localStorage.setItem('institutionStore', JSON.stringify(state))
}

function resetPersistence() {
  localStorage.removeItem('institutionStore')
}

export default {
  SELECT_ACTIVE_ENTITY(state: {active_entity: any}, entity: any) {
    state.active_entity = entity
    persistState(state)
  },
  CLEAR_ACTIVE_ENTITY(state: {active_entity: any, institutions: Array<any>}, id: number) {
    state.active_entity = null
    persistState(state)
  },
  RESET_STORE(state: any) {
    state = newState()
    resetPersistence()
  }
}
